// services/api.ts
import { client_product } from '../client';
import { CREATE_PRODUCT_MUTATION, DELETE_PRODUCT_MUTATION, GET_ALL_PRODUCTS_QUERY, UPDATE_PRODUCT_MUTATION } from '../userQuery';
import { ProductInput,Product} from '../../interfaces/adminproduct';
 import {print} from 'graphql';

const API_BASE = 'http://localhost:5000';

const env = process.env.REACT_APP_ENV_SETTINGS;
const token = localStorage.getItem("token");


export const fetchProducts = async () => {
  if (env === "dev") {
    const res = await  fetch(`${API_BASE}/products`);
    return res.json();
  } else {
    const { data } = await client_product.query({ query: GET_ALL_PRODUCTS_QUERY });
    return data.products;
  }
};

// Updated createProduct
export const createProduct = async (
  product: ProductInput | FormData
): Promise<Product> => {
  try {
    const input: any = {};
    const uploads: File[] = [];

    if (product instanceof FormData) {
      product.forEach((value, key) => {
        if (key === "image" || key === "video") {
          uploads.push(value as File);
        } else if (["price", "stockQuantity", "discountPrice", "marginPrice","gst"].includes(key)) {
          input[key] = parseFloat(String(value));
        } else if (key === "rewardFlag") {
          input[key] = String(value).toLowerCase() === "true";
        } else if (["attributes", "variants"].includes(key)) {
          input[key] = JSON.parse(String(value));
        } else if (key === "highlights") {
          input[key] = String(value).split(",").map((s) => s.trim());
        } else {
          input[key] = value;
        }

        if (key === "attributes") {
          const parsed = JSON.parse(String(value));
          input.attributes = Array.isArray(parsed) ? parsed : parsed.attributes;
        } else if (key === "variants") {
          input.variants = JSON.parse(String(value));
        }
      });

      input.slug = input.name?.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "") || "";
      input.discountedPrice = parseFloat(input.discountedPrice) || 0;
      input.marginPrice = parseFloat(input.marginPrice) || 0;
      input.gst = parseFloat(input.gst) || 0;
      input.currency = "IND";

      input.attributes = input.attributes || [];

      if (input.color) input.attributes.push({ key: "Color", value: input.color });
      if (input.weight) input.attributes.push({ key: "Weight", value: input.weight });

      input.images = uploads.map(() => null);
    } else {
      Object.assign(input, product);
      if (!input.slug && input.name) {
        input.slug = input.name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
      }
    }

    const operations = {
      query: print(CREATE_PRODUCT_MUTATION),
      variables: { input },
    };

    const map: Record<string, string[]> = {};
    uploads.forEach((_, i) => {
      map[i] = [`variables.input.images.${i}`];
    });

    const formData = new FormData();
    formData.append("operations", JSON.stringify(operations));
    formData.append("map", JSON.stringify(map));
    uploads.forEach((file, i) => {
      formData.append(String(i), file);
    });

    const res = await fetch(process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL!, {
      method: "POST",
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: formData,
    });

    const json = await res.json();
    if (json.errors?.length) throw new Error(json.errors[0].message);

    return json.data.createProduct;
  } catch (error) {
    console.error("Error in createProduct:", error);
    throw error;
  }
};



export const updateProduct = async (
  id: string,
  product: ProductInput | FormData
): Promise<Product> => {
  try {
    const input: any = {};
    const uploads: File[] = [];

    console.log("data received",product);

    if (product instanceof FormData) {
      product.forEach((value, key) => {
        if (key === "image" || key === "video") {
          uploads.push(value as File);
        } else if (["price", "stockQuantity", "discountPrice", "marginPrice","gst"].includes(key)) {
          input[key] = parseFloat(String(value));
        } else if (key === "rewardFlag") {
          input[key] = String(value).toLowerCase() === "true";
        } else if (["attributes", "variants"].includes(key)) {
          input[key] = JSON.parse(String(value));
        } else if (key === "highlights") {
          input[key] = String(value).split(",").map((s) => s.trim());
        } else {
          input[key] = value;
        }

        if (key === "attributes") {
          const parsed = JSON.parse(String(value));
          input.attributes = Array.isArray(parsed) ? parsed : parsed.attributes;
        } else if (key === "variants") {
          input.variants = JSON.parse(String(value));
        }
      });

      

      input.slug = input.name?.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "") || "";
      input.discountedPrice = input.discountedPrice;

      input.attributes = input.attributes || [];

      if (input.color) input.attributes.push({ key: "Color", value: input.color });
      if (input.weight) input.attributes.push({ key: "Weight", value: input.weight });

      input.images = uploads.map(() => null);
    } else {
      Object.assign(input, product);
      if (!input.slug && input.name) {
        input.slug = input.name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
      }
    }
  console.log("GraphQL variables:", { id, input });


    const operations = {
      query: print(UPDATE_PRODUCT_MUTATION),
      variables: { id, input },
    };

    const map: Record<string, string[]> = {};
    uploads.forEach((_, i) => {
      map[i] = [`variables.input.images.${i}`];
    });

    const formData = new FormData();
    formData.append("operations", JSON.stringify(operations));
    formData.append("map", JSON.stringify(map));
    uploads.forEach((file, i) => {
      formData.append(String(i), file);
    });

    const res = await fetch(process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL!, {
      method: "POST",
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: formData,
    });

    const json = await res.json();
    if (json.errors?.length) throw new Error(json.errors[0].message);

    return json.data.updateProduct;
  } catch (error) {
    console.error("Error in updateProduct:", error);
    throw error;
  }
};


// Updated deleteProduct
export const deleteProduct = async (id: string): Promise<boolean> => {
  if (env === "dev") {
    await fetch(`${API_BASE}/products/${id}`, {
      method: 'DELETE',
    });
    return true;
  } else {
    const { data } = await client_product.mutate({
      mutation: DELETE_PRODUCT_MUTATION,
      variables: { id },
    });
    return data.deleteProduct;
  }
};

